import "styles/sections/modular-card-grid.css";
import "scripts/sections/index-collection-carousel-peek.js";

(function () {
  function initSlickIn(root) {
    var $ = window.jQuery || window.$;
    if (!$) return;

    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(".modular-card-grid-section .mcg__grid[data-slick]").forEach(function (el) {
      if (!el.classList.contains("slick-initialized")) {
        $(el).slick();
      }
    });
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (e.target && e.target.classList && e.target.classList.contains("modular-card-grid-section")) {
      initSlickIn(e.target);
    }
  });
})();
